module.exports = __webpack_public_path__ + "img/product_48.8f4b2f7.webp";